import { render, staticRenderFns } from "./StoreManagement.vue?vue&type=template&id=1f020e9f&scoped=true"
import script from "./StoreManagement.vue?vue&type=script&lang=js"
export * from "./StoreManagement.vue?vue&type=script&lang=js"
import style0 from "./StoreManagement.vue?vue&type=style&index=0&id=1f020e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f020e9f",
  null
  
)

export default component.exports